<div class="user-wrapper">

  <div class="user-details">
    <div class="lh-1 fw-bold">Keycloak Information</div>
    <div class="details-body">
      <div class="avatar">
        <i class="fa-solid fa-user"></i>
      </div>
      <div class="information-wrapper">
        <div class="information-section">
          <div class="information-section-label">ID</div>
          <div class="information-section-value secondary-lighter" [oaiboxCopy]="user.id">{{ user.id }}</div>
        </div>
        <div class="information-section">
          <div class="information-section-label">Email</div>
          <div class="information-section-value secondary-lighter" [oaiboxCopy]="user.userEmail">{{ user.userEmail}}</div>
        </div>
        <div class="information-section">
          <div class="information-section-label">Username</div>
          <div class="information-section-value secondary-lighter" [oaiboxCopy]="user.username">{{ user.username}}</div>
        </div>
      </div>
    </div>
  </div>

  <div class="user-details default-tenant">
    <div class="lh-1 fw-bold">Default Tenant</div>
    <div class="details-body">
      <i class="default-tenant-icon square-icon fa-duotone fa-solid fa-building-user"></i>
      <div class="information-wrapper">
        <div class="information-section">
          <div class="information-section-label">ID</div>
          @if (tenant && tenant.id) {
            <div class="information-section-value secondary-lighter" [oaiboxCopy]="tenant.id">{{ tenant.id }}</div>
          }
          @else {
            <div class="information-section-value secondary-lighter">--</div>
          }
        </div>
        <div class="information-section">
          <div class="information-section-label">Name</div>
          @if (tenant && tenant.clientName) {
            <div class="information-section-value secondary-lighter" [oaiboxCopy]="tenant.clientName">{{ tenant.clientName }}</div>
          }
          @else {
            <div class="information-section-value secondary-lighter">--</div>
          }
        </div>
        <div class="information-section">
          <div class="information-section-label">Description</div>
          @if (tenant && tenant.clientDescription) {
            <div class="information-section-value secondary-lighter" [oaiboxCopy]="tenant.clientDescription">{{ tenant.clientDescription }}</div>
          }
          @else {
            <div class="information-section-value secondary-lighter">--</div>
          }
        </div>
      </div>
    </div>
  </div>

  <div class="management-buttons-wrapper">
    <button class="management-button danger" oaiboxBsPopover="Delete User" trigger="hover"
            container="body" placement="bottom" (click)="deleteUser()">
      <i class="fa-solid fa-trash"></i>
    </button>
  </div>
</div>
